import { Building2, Briefcase, GraduationCap, Building, ShoppingBag, Stethoscope } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Industries() {
  const industries = [
    {
      icon: <Building2 className="h-12 w-12" />,
      title: 'Banking & Finance',
      description: 'Digital solutions for modern banking, including secure transactions, mobile banking, and financial management systems.',
      image: 'https://images.unsplash.com/photo-1556742044-3c52d6e88c62?auto=format&fit=crop&q=80&w=1920',
      features: ['Digital Banking', 'Payment Systems', 'Risk Management', 'Regulatory Compliance']
    },
    {
      icon: <Briefcase className="h-12 w-12" />,
      title: 'Professional Services',
      description: 'Technology solutions for law firms, consulting companies, and other professional service providers.',
      image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&q=80&w=1920',
      features: ['Practice Management', 'Client Portals', 'Document Management', 'Workflow Automation']
    },
    {
      icon: <GraduationCap className="h-12 w-12" />,
      title: 'Education',
      description: 'Digital learning platforms, student management systems, and educational technology solutions.',
      image: 'https://images.unsplash.com/photo-1523580494863-6f3031224c94?auto=format&fit=crop&q=80&w=1920',
      features: ['Learning Management', 'Student Information', 'Virtual Classrooms', 'Assessment Tools']
    },
    {
      icon: <Building className="h-12 w-12" />,
      title: 'Real Estate',
      description: 'Property management systems, virtual tours, and real estate technology solutions.',
      image: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&q=80&w=1920',
      features: ['Property Management', 'Virtual Tours', 'Client Portals', 'Market Analytics']
    },
    {
      icon: <ShoppingBag className="h-12 w-12" />,
      title: 'Retail & E-commerce',
      description: 'Online store platforms, inventory management, and retail technology solutions.',
      image: 'https://images.unsplash.com/photo-1472851294608-062f824d29cc?auto=format&fit=crop&q=80&w=1920',
      features: ['E-commerce Platforms', 'Inventory Management', 'POS Systems', 'Customer Analytics']
    },
    {
      icon: <Stethoscope className="h-12 w-12" />,
      title: 'Healthcare',
      description: 'Healthcare management systems, patient portals, and medical technology solutions.',
      image: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?auto=format&fit=crop&q=80&w=1920',
      features: ['Patient Management', 'Electronic Records', 'Telemedicine', 'Healthcare Analytics']
    }
  ];

  return (
    <div className="py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Industries We Serve</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We provide specialized IT solutions across various industries, helping businesses thrive in the digital age
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {industries.map((industry, index) => (
            <div key={index} className="group bg-white rounded-lg shadow-lg overflow-hidden transform hover:-translate-y-1 transition-all duration-300">
              <div className="relative h-64">
                <img
                  src={industry.image}
                  alt={industry.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/50 to-transparent group-hover:from-black/90 transition-all duration-300">
                  <div className="absolute bottom-0 p-6 text-white">
                    <div className="text-blue-400 mb-3">{industry.icon}</div>
                    <h2 className="text-2xl font-bold mb-2">{industry.title}</h2>
                    <p className="text-white/90">{industry.description}</p>
                  </div>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-lg font-semibold mb-4">Industry Solutions</h3>
                <ul className="grid grid-cols-2 gap-3">
                  {industry.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-center text-gray-700">
                      <span className="w-2 h-2 bg-blue-600 rounded-full mr-2"></span>
                      {feature}
                    </li>
                  ))}
                </ul>
                <Link
                  to="/contact"
                  className="inline-flex items-center text-blue-600 mt-6 hover:text-blue-700 transition-colors"
                >
                  Learn More
                  <span className="ml-2">→</span>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}